<template>
    <div class="my-collection-container">
      <!-- <div class="custom-header">
        
          <h1>My Collections</h1>
        
      </div> -->
      <el-main >
        <div class="tabs-header" >
          <el-tabs v-model="activeTab" class="demo-tabs" @tab-click="handleTabClick" >
            <el-tab-pane label="Acquired from others" name="purchased" >
              <div class="posts-container">
                <div class="view-mode-selector">
                  <el-radio-group v-model="viewMode" size="small">
                    <el-radio-button label="list">
                      <i class="el-icon-menu"></i>
                    </el-radio-button>
                    <el-radio-button label="grid">
                      <i class="el-icon-s-grid"></i>
                    </el-radio-button>
                  </el-radio-group>
                </div>
                <el-skeleton :rows="3" animated v-if="purchasedLoading"/>
                <template v-else >
                  <template v-if="viewMode === 'list'">
                    <Collection
                      v-for="collection in purchasedPosts"
                      :key="collection._id && (collection._id.$oid || collection._id.$id) ? (collection._id.$oid || collection._id.$id) : collection.id || collection._id || Math.random()"
                      :collection="collection"
                      @like="handleLike"
                    />
                  </template>
                  <div v-else class="grid-container">
                    <CollectionSimpleCard
                      v-for="collection in purchasedPosts"
                      :key="collection._id && (collection._id.$oid || collection._id.$id) ? (collection._id.$oid || collection._id.$id) : collection.id || collection._id || Math.random()"
                      :collection="collection"
                      @click="goToCollection((collection._id && (collection._id.$oid || collection._id.$id)) ? (collection._id.$oid || collection._id.$id) : (collection.id || ''))"
                    />
                  </div>
                  <div v-if="purchasedPosts.length === 0" class="empty-state">
                    <p>You haven't purchased any Course yet.</p>
                    <!-- <el-button type="primary" @click="$router.push('/square')">
                      Visit Square
                    </el-button> -->
                  </div>
                </template>
              </div>
            </el-tab-pane>
            
            <el-tab-pane label="Created by me" v-if="['Pro', 'Supreme'].includes(creator_functionality_level)" name="created">
              <div class="posts-container">
                <div class="tab-header">
                  <div class="view-mode-selector">
                    <el-radio-group v-model="viewMode" size="small">
                      <el-radio-button label="list">
                        <i class="el-icon-menu"></i>
                      </el-radio-button>
                      <el-radio-button label="grid">
                        <i class="el-icon-s-grid"></i>
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                  <el-button type="primary" @click="handleNewCollection">
                    + New Course
                  </el-button>
                </div>
                <el-skeleton :rows="3" animated v-if="createdLoading"/>
                <template v-else>
                  <template v-if="viewMode === 'list'">
                    <Collection
                      v-for="collection in createdCollections"
                      :key="collection._id && (collection._id.$oid || collection._id.$id) ? (collection._id.$oid || collection._id.$id) : collection.id || collection._id || Math.random()"
                      :collection="collection || {}"
                      @like="handleLike"
                      @publicity-updated="handlePublicityUpdated"
                    />
                  </template>
                  <div v-else class="grid-container">
                    <CollectionSimpleCard
                      v-for="collection in createdCollections"
                      :key="collection._id && (collection._id.$oid || collection._id.$id) ? (collection._id.$oid || collection._id.$id) : collection.id || collection._id || Math.random()"
                      :collection="collection || {}"
                      @click="goToCollection((collection._id && (collection._id.$oid || collection._id.$id)) ? (collection._id.$oid || collection._id.$id) : (collection.id || ''))"
                    />
                  </div>
                  <div v-if="createdCollections.length === 0" class="empty-state">
                    <p>You haven't created any Course yet.</p>
                    <el-button type="primary" @click="$router.push('/new-collection')">
                      Create Your First Course
                    </el-button>
                  </div>
                </template>
              </div>
            </el-tab-pane>
            
            <el-tab-pane label="My Bundles" name="bundles">
              <div class="posts-container">
                <div class="tab-header">
                  <div class="view-mode-selector">
                    <el-radio-group v-model="viewMode" size="small">
                      <el-radio-button label="list">
                        <i class="el-icon-menu"></i>
                      </el-radio-button>
                      <el-radio-button label="grid">
                        <i class="el-icon-s-grid"></i>
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                  <el-button type="primary" @click="handleNewBundle">
                    + New Bundle
                  </el-button>
                </div>
                <el-skeleton :rows="3" animated v-if="bundlesLoading"/>
                <template v-else>
                  <template v-if="viewMode === 'list'">
                    <BundleSimple
                      v-for="bundle in bundles"
                      :key="bundle._id?.$oid || bundle._id?.$id || bundle.id"
                      :bundle="bundle || {}"
                      @click.native="handleBundleClick(bundle)"
                    />
                  </template>
                  <div v-else class="grid-container">
                    <BundleSimple
                      v-for="bundle in bundles"
                      :key="bundle._id?.$oid || bundle._id?.$id || bundle.id"
                      :bundle="bundle || {}"
                      @click.native="handleBundleClick(bundle)"
                    />
                  </div>
                  <div v-if="bundles.length === 0" class="empty-state">
                    <p>You haven't created any Knowit Bundle yet.</p>
                    <el-button type="primary" @click="$router.push('/new-bundle')">
                      Create Your First Knowit Bundle
                    </el-button>
                  </div>
                </template>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-main>
    </div>
  </template>
  
  <script>
  import Collection from '@/components/Collection.vue'
  import CollectionSimpleCard from '@/components/CollectionSimpleCard.vue'
  import BundleSimple from '@/components/BundleSimple.vue'
  import { postRequest } from '@/apis/front'
  
  export default {
    name: 'MyCollections',
    components: {
      Collection,
      CollectionSimpleCard,
      BundleSimple,
    },
    data() {
      return {
        activeTab: localStorage.getItem('myCollectionTab') || 'purchased',
        purchasedPosts: [],
        createdCollections: [],
        purchasedLoading: false,
        createdLoading: false,
        viewMode: localStorage.getItem('collectionViewMode') || 'list',
        bundles: [],
        bundlesLoading: false,
      }
    },
    watch: {
      viewMode(newMode) {
        localStorage.setItem('collectionViewMode', newMode)
      }
    },
    mounted() {
      this.$nextTick(() => {  // Ensure DOM is updated
        this.fetchPurchasedPosts()
        this.fetchCreatedCollections()
        this.fetchBundles()
      })
    },
    computed: {
      creator_functionality_level() {
        return this.$store.state.user_info.creator_functionality_level || 'Basic';
      }
    },
    methods: {
      handleTabClick(tab) {
        this.activeTab = tab.paneName
        localStorage.setItem('myCollectionTab', tab.paneName)
      },
      async fetchPurchasedPosts() {
        this.purchasedLoading = true
        try {
          const response = await postRequest('getMyPurchasedPostCollections', {
            user_id: this.$store.state.user_id,
          })
          
          if (response.data.code === 0) {
            this.purchasedPosts = response.data.data
            this.purchasedLoading = false
          } else {
            this.$message.error(response.data.msg || 'Failed to fetch purchased posts')
          }
        } catch (error) {
          console.error('Error fetching purchased posts:', error)
          this.$message.error('Failed to fetch purchased posts')
        } finally {
          this.purchasedLoading = false
        }
      },
      
      async fetchCreatedCollections() {
        this.createdLoading = true
        try {
          const response = await postRequest('getMyPostCollections', {
            user_id: this.$store.state.user_id,
          })
          
          if (response.data.code === 0) {
            this.createdCollections = response.data.data
          } else {
            this.$message.error(response.data.msg || 'Failed to fetch created posts')
          }
        } catch (error) {
          console.error('Error fetching created posts:', error)
          this.$message.error('Failed to fetch created posts')
        } finally {
          this.createdLoading = false
        }
      },
      handleLike(postId) {
        console.log('Like post:', postId)
      },
      handlePublicityUpdated(update) {
        const index = this.createdCollections.findIndex(collection => {
          const objectId = collection._id && (collection._id.$oid || collection._id.$id)
          const id = objectId || collection.id || collection._id
          return id === update.collection_id
        })
        if (index === -1) return

        this.$set(this.createdCollections, index, {
          ...this.createdCollections[index],
          subscribers_only: update.subscribers_only,
          status: update.status,
          settings: update.settings
        })
      },
      handleComment(postId) {
        console.log('Comment on post:', postId)
      },
      handleNewCollection() {
        localStorage.setItem('editCollectionId', '')
        this.$router.push('/new-collection')
      },
      async fetchBundles() {
        this.bundlesLoading = true
        try {
          const response = await postRequest('getMyCollectionBundles', {
            user_id: this.$store.state.user_id,
            include_collections: true
          })
          
          if (response.data.code === 0) {
            this.bundles = response.data.data
          } else {
            this.$message.error(response.data.msg || 'Failed to fetch bundles')
          }
        } catch (error) {
          console.error('Error fetching bundles:', error)
          this.$message.error('Failed to fetch bundles')
        } finally {
          this.bundlesLoading = false
        }
      },
      handleNewBundle() {
        localStorage.setItem('editBundleId', '')
        this.$router.push('/new-bundle')
      },
      handleBundleClick(bundle) {
        console.log('bundle:', bundle)
        this.$store.dispatch('setTempBundleId', bundle._id?.$oid || bundle._id?.$id || bundle.id)
        this.$router.push('/bundle')
      },
      goToCollection(collectionId) {
        this.$store.dispatch('setTempCollectionId', collectionId)
        this.$router.push({ path: '/read-collection', query: { source: 'created' } })
      },
    }
  }
  </script>
  
  <style scoped>
  .my-collection-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 0;
  }
  
  .custom-header {
    background-color: #409EFF;
    color: white;
    padding-left: 20px;
    width: 100%;
    height: 64px;
    flex-shrink: 0;
  }
  
  .el-main {
    padding: 20px;
    width: 100%;
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  
  .posts-container {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px 0;
    flex: 1;
  }
  
  .empty-state {
    text-align: center;
    padding: 40px;
    color: #909399;
  }
  
  .empty-state p {
    margin-bottom: 20px;
  }
  
  .tabs-header {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    background: white;
    position: sticky;
    top: 0;
    z-index: 100;
    padding: 0;
    max-width: 1400px;
    margin: 0 auto;
    width: 100%;
    min-width: 0;
  }
  
  .section-title {
    margin: 0;
    white-space: nowrap;
  }
  
  .demo-tabs {
    background: white;
    width: 100%;
  }
  
  .el-tabs__content {
    width: 100%;
  }
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1400px;
    margin: 0 auto;
    padding: 10px 20px; /* Reduced padding from 20px to 10px vertical */
    height: 100%;
  }
  
  .tab-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-right: 20px;
  }
  
  .view-mode-selector {
    margin-left: auto;
    margin-right: 20px;
  }
  
  .grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 20px;
    padding: 20px;
  }
  </style>
